import { css } from 'linaria';

export namespace Styles {
  export const modalContent = css`
    flex-grow: 1;
    outline: 1px solid lightblue;
  `;

  export const layout = css`
    position: relative;
    display: flex;
    flex-direction: row;
    flex-direction: column;
    flex-wrap: nowrap;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-right: 0;
    background-color: #ffffff;
    border-radius: 0;
  `;

  export const closeButton = css`
    position: absolute;
    top: 8px;
    right: 8px;

    background-color: var(--control-invert);
  `;

  export const thumbsContainer = css`
    position: relative;
    display: block;
    order: 1;

    flex-basis: 80px;
    box-sizing: border-box;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 0;
  `;

  export const thumbsScroller = css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    height: 64px;
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      display: none;
    }
  `;

  export const thumbsScrollerMobile = css`
    height: 48px;
  `;

  export const thumb = css`
    position: relative;
    display: block;
    box-sizing: border-box;
    width: 64px;
    height: 64px;
    padding: 6px;
    margin: 0;
    margin-left: 8px;
    background-color: transparent;
    border: 2px solid;
    border-color: transparent;
    border-radius: 4px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    &:active {
      border-color: var(--hover-minor);
    }

    @media (hover: hover) {
      &:hover {
        border-color: var(--hover-minor);
      }
    }
  `;

  export const thumbActive = css`
    border-color: var(--control-primary);
  `;

  export const thumbMobile = css`
    width: 48px;
    height: 48px;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 8px;
  `;

  export const thumbImg = css`
    display: block;
    box-sizing: border-box;
    width: 48px;
    height: 48px;
  `;

  export const thumbImgMobile = css`
    width: 32px;
    height: 32px;
  `;

  export const photoViewport = css`
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    box-sizing: border-box;
    padding: 0;
    overflow: hidden;
  `;

  export const contentPicture = css`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  `;
}
